
import axios from "axios";
import { Config } from "../../config";


export const GetReviewProduct = async (
  token: string,
  type: any,
  store_id?: any,
  order_id?: any,
  product_id?: any,
  review_id?: any,
  limit?: any,
  offset?: any,
  filter?: any,
  filterscore?: any
) => {
  try {
    const data = await axios({
      method: "get",
      maxBodyLength: Infinity,
      url:
        Config.apiEndpoint +
        `product/review-product?type=${type}&store_id=${store_id}&order_id=${order_id}&product_id=${product_id}&review_id=${review_id}&limit=${limit}&offset=${offset}&filter=${filter}&filter_score=${filterscore}`,
        // `product/review-product?type=${type}&product_id=${product_id}&filter=${filter}&filter_score=${filterscore}`,
      headers: {
        "accept-language": "th",
        Authorization: "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    });
    return data.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const GetReviewProductInStore = async (
  token: string,
  type: any,
  store_id?: any,
  order_id?: any,
  product_id?: any,
  review_id?: any,
  limit?: any,
  offset?: any,
  filter?: any,
  filterscore?: any
) => {
  try {
    const data = await axios({
      method: "get",
      maxBodyLength: Infinity,
      url:
        Config.apiEndpoint +
        `product/review-product?type=${type}&store_id=${store_id}&order_id=${order_id}&product_id=${product_id}&review_id=${review_id}&limit=${limit}&offset=${offset}&filter=${filter}&filter_score=${filterscore}`,
        // `product/review-product?type=${type}&product_id=${product_id}&filter=${filter}&filter_score=${filterscore}`,
      headers: {
        "accept-language": "th",
        Authorization: "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    });
    return data.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const GetReviewProductWithOrder = async (
  token: string,
  type: any,
  order_id?: any,
) => {
  try {
    const data = await axios({
      method: "get",
      maxBodyLength: Infinity,
      url:
        Config.apiEndpoint +
        // `product/review-product?type=${type}&store_id=${store_id}&order_id=${order_id}&product_id=${product_id}&review_id=${review_id}&limit=${limit}&offset=${offset}&filter=${filter}&filter_score=${filterscore}`,
        `product/review-product?type=${type}&order_id=${order_id}`,
      headers: {
        "accept-language": "th",
        Authorization: "Basic " + Config.encoded,
        "x-access-token": token,
        "Content-Type": "application/json",
      },
    });
    return data.data;
  } catch (error) {
    console.error("Error:", error);
  }
};